<template>
  <BModal
    :model-value="visible"
    title="New Password Generated"
    :ok-only="true"
    ok-title="Done"
    @update:model-value="$emit('update:visible', $event)"
  >
    <p><strong>Username:</strong> {{ props.data?.username }}</p>
    <p class="mb-2">
      <strong>New Temporary Password:</strong>
    </p>
    <BInputGroup>
      <BFormInput
        :model-value="props.data?.temp_password"
        readonly
        class="font-monospace"
      />
      <BButton
        variant="primary"
        :disabled="showCopiedMessage"
        @click="handleCopy"
      >
        {{ showCopiedMessage ? "✓ Copied!" : "📋 Copy" }}
      </BButton>
    </BInputGroup>
  </BModal>
</template>

<script setup lang="ts">
import { ref } from "vue";
import { BModal, BInputGroup, BFormInput, BButton } from "bootstrap-vue-next";

interface PasswordData {
  username: string;
  temp_password: string;
}

const props = defineProps<{
  visible: boolean;
  data: PasswordData | null;
}>();

const showCopiedMessage = ref(false);

const emit = defineEmits<{
  "update:visible": [value: boolean];
  copy: [password: string];
}>();

const handleCopy = async () => {
  if (!props.data?.temp_password) return;
  
  try {
    await navigator.clipboard.writeText(props.data.temp_password);
    emit("copy", props.data.temp_password);
    showCopiedMessage.value = true;
    setTimeout(() => {
      showCopiedMessage.value = false;
    }, 3000);
  } catch (error) {
    console.error("Failed to copy to clipboard:", error);
  }
};
</script>
